// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-footer--fixed[data-v-677ffd00] {
  z-index: 7 !important;
}
.nav-footer-fix[data-v-677ffd00] {
  border-top: unset;
  z-index: unset;
}
.main-content-container[data-v-677ffd00] {
  padding: 20px 32px;
}
.navbar-slot[data-v-677ffd00] {
  width: 600px;
  height: 60px;
  max-width: calc(100% - 203px);
  display: inline-block;
  background-color: var(--panel-background);
  border-radius: var(--border-radius);
  padding: 6px 15px;
  margin: auto;
  margin-top: 15px;
  margin-left: 25%;
}
.navbar-slot .collector-panel[data-v-677ffd00] {
  display: inline-block;
  width: 49%;
  height: 50px;
}
.navbar-slot .org-change-field[data-v-677ffd00] {
  margin-top: 5px;
  display: inline-block;
  width: 49%;
}`, "",{"version":3,"sources":["webpack://./js/modules/admin/components/App/Main.vue","webpack://./Main.vue"],"names":[],"mappings":"AACA;EACE,qBAAA;ACAF;ADGA;EACE,iBAAA;EACA,cAAA;ACAF;ADEA;EAEE,kBAAA;ACAF;ADEA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,yCAAA;EACA,mCAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;ACCF;ADCE;EACE,qBAAA;EACA,UAAA;EACA,YAAA;ACCJ;ADCE;EACE,eAAA;EACA,qBAAA;EACA,UAAA;ACCJ","sourcesContent":["\n.v-footer--fixed {\n  z-index: 7!important;\n}\n\n.nav-footer-fix {\n  border-top: unset;\n  z-index: unset;\n}\n.main-content-container {\n  // top padding is hidden under the navbar and acts as a spacer only\n  padding: 20px 32px;\n}\n.navbar-slot {\n  width: 600px;\n  height: 60px;\n  max-width: calc(100% - 203px);\n  display: inline-block;\n  background-color: var(--panel-background);\n  border-radius: var(--border-radius);\n  padding: 6px 15px;\n  margin: auto;\n  margin-top: 15px;\n  margin-left: 25%;\n\n  .collector-panel {\n    display: inline-block;\n    width: 49%;\n    height: 50px;\n  }\n  .org-change-field {\n    margin-top: 5px;\n    display: inline-block;\n    width: 49%;\n  }\n}\n",".v-footer--fixed {\n  z-index: 7 !important;\n}\n\n.nav-footer-fix {\n  border-top: unset;\n  z-index: unset;\n}\n\n.main-content-container {\n  padding: 20px 32px;\n}\n\n.navbar-slot {\n  width: 600px;\n  height: 60px;\n  max-width: calc(100% - 203px);\n  display: inline-block;\n  background-color: var(--panel-background);\n  border-radius: var(--border-radius);\n  padding: 6px 15px;\n  margin: auto;\n  margin-top: 15px;\n  margin-left: 25%;\n}\n.navbar-slot .collector-panel {\n  display: inline-block;\n  width: 49%;\n  height: 50px;\n}\n.navbar-slot .org-change-field {\n  margin-top: 5px;\n  display: inline-block;\n  width: 49%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
